module.exports = __webpack_public_path__ + "img/add-section-icon.8b94c1a6.svg";